import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { Form, FormGroup } from 'reactstrap';
import { Label } from 'reactstrap';
import { Button } from 'reactstrap';
import { replace, useNavigate } from 'react-router-dom'
import { Navigate } from "react-router-dom";
//import { withRouter } from "react-router";
import { browserHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import withNavigateHook from '../../myRoutes';

class Logout extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            db: "",
            firstname: "",
            email:"",
            userRole:""
        }
    }
    
    appLogout = () => {
      
        this.props.navigate('/', { replace: true,
            state: {
                db: '', email: '', firstname: '', userRole:""
            }
        });
        
    }
    componentDidMount =()=>{
        if ((this.props.location.state.db ==="")|| (this.props.location.state.email ==="")||
            (this.props.location.state.firstname ==="") || (this.props.location.state.userRole==="")){
                this.appLogout();
            }
    }
    render() {
        return (
            <Form onSubmit={this.GotoOther}>
                <div className='mainDivHome'>
                    <div style={{ paddingTop: "10px" }}>
                        <span style={{ fontStyle: "italic" }}><label>Welcome To the Test Page...</label></span>
                        {/* <span style={{ fontStyle: "italic" }}><label>, today is {this.state.date}</label></span> */}
                    </div>
                    <div>
                        <div>
                            {(() => {
                                if (this.state.divCondition) {
                                    return (
                                        <div>
                                            <p>Welcome!</p>
                                            <button>Logout</button>
                                        </div>
                                    );
                                } else {
                                    return (
                                        <div>
                                            <p>Please log in.</p>
                                            <button>Login</button>
                                        </div>
                                    );
                                }
                            })()}
                        </div>

                        <div style={{ paddingTop: "20px" }}>
                            <Button style={{ backgroundColor: "rgb(89, 100, 95)", width: "100%" }} type="submit">Submit</Button>
                        </div>

                    </div>
                </div>

            </Form>
        );
    }
}

export default withNavigateHook(Logout);